import { helpers } from 'veritone-redux-common';
const { createReducer } = helpers;

export const LOADING_DATA = 'mentions/query-folder-loading';
export const QUERY_FOLDER = 'metions/query-folder';
export const LOADED_DATA = 'mentions/query-folder-loaded';
export const QUERY_FOLDER_SAGA = 'metions/query-folder-saga';
export const CREATE_FOLDER = 'mentions/create-folder';
export const CREATE_FOLDER_SAGA = 'mentions/create-folder-saga';
export const SET_ATTRIBUTION_FOLDER = 'mentions/set-attribution-folder';

const defaultState = {
    byId: {},
    allIds: []
}

const folderReducer = createReducer(defaultState, {
    [LOADING_DATA]: (state, action) => ({
        ...state,
        loading: true,
        loaded: false
    }),

    [LOADED_DATA]: (state, action) => ({
        ...state,
        loading: false,
        loaded: true
    }),

    [QUERY_FOLDER]: (state, action) => {
        const { folders } = action.payload;
        return folders.reduce((acc, folder) => {
            const { id, name="", subfolders, ownerId } = folder;
            const subfolderList = (subfolders || []).reduce((subfolderAcc, { id, name }) => ({
                ...subfolderAcc,
                [id]: {
                    id,
                    name
                }
            }), {});
            return {
                byId: {
                    ...acc.byId,
                    [id]: {
                        id,
                        ownerId,
                        name
                    },
                    ...subfolderList
                },
                allIds: [
                    ...acc.allIds,
                    id,
                    ...(subfolders || []).map(({ id }) => id)
                ]
            }
        }, { byId: {}, allIds: []})
    },

    [CREATE_FOLDER]: (state, action) => {
        const { folder: { id, name } } = action.payload;
        return {
            byId: {
                ...state.byId,
                [id]: {
                    id,
                    name
                }
            },
            allIds: [
                ...state.allIds,
                id
            ]
        }
    },
    [SET_ATTRIBUTION_FOLDER]: (state, action) => {
        return {
        ...state,
        byId: {
            ...state.byId,
            'attribution': action.payload.folder
            }
        }
    }
})

export const loadingFolder = () => ({
    type: LOADING_DATA
})

export const loadedFolder = () => ({
    type: LOADED_DATA
})

export const queryFolder = (folders) => ({
    type: QUERY_FOLDER,
    payload: { folders }
})

export const createFolder = (folder) => ({
    type: CREATE_FOLDER,
    payload: { folder }
})

export const queryFolderSaga = () => ({
    type: QUERY_FOLDER_SAGA
})

export const createFolderSaga = (folder) => ({
    type: CREATE_FOLDER_SAGA,
    payload: { folder }
})

export const setAttribution = (folder) => ({
    type: SET_ATTRIBUTION_FOLDER,
    payload: { folder }
})

export const getFolders = (state) => state.mentions.folders.allIds.map(folderId => state.mentions.folders.byId[folderId]);
export const getAttributionFolder = state => state.mentions.folders.byId.attribution;

export default folderReducer;